// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
// ##### 25-05-21 Komarov
import ScrollToTopButton from './Components/Library/PageDevices/ScrollToTopButton/ScrollToTopButton';
// ##### 23-06-19 Komarov
import { PaymentServiceProvider } from './Components/Context/PaymentServiceContext';
// ##### 25-05-21 Komarov
import LocalizationWrapper from './LocalizationWrapper';
import config from './Redux/config';
import PaymentService from './Redux/services/payment.service';
// ##### 23-12-28 Komarov
import { loggedIn } from './Redux/actions/auth';
// ##### 24-07-25 Komarov
import { useDispatch, useSelector } from 'react-redux';
// ##### 24-08-05 Komarov
import moment from 'moment';
import { setPromoCode } from './Redux/actions/promocode';
// ##### 25-04-17 Komarov
import { uniLog } from '../server/helpers/uniLog';
import GtagInit from './Components/Library/SEO/GtagInit';
import { setDevMode } from './Redux/actions';
import { isDeveloperMode } from './helpers/isDeveloperLogin';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from './hooks/usePerformanceMeasure';
// ##### Komarov 2025-10-06: Add RobotsMeta for SEO
import RobotsMeta from './Components/Seo/RobotsMeta';

const paymentService = new PaymentService();

const supportedLangs = config.supportedLangs.join('|');
// ##### 24-03-21 Komarov
process.env.NODE_ENV === 'development' &&
  // ##### 25-04-30 Komarov
  uniLog('src/App.js:window.INITIAL_STATE', window.INITIAL_STATE);

// ##### Komarov 2025-07-14
const App = () => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('App', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for App (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  const dispatch = useDispatch();
  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (isDeveloperMode()) {
      dispatch(setDevMode());
    }
  }, [dispatch]);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-02-26 Komarov: Выводим в клиентскую консоль выводы серверной консоли
    uniLog('src/App.js: console.logs from server', window.INITIAL_STATE.data);

    // ##### 25-03-04 Komarov
    const errorsCities = window.INITIAL_STATE.cities.errors;
    if (process.env.NODE_ENV === 'development' && errorsCities.length > 0) {
      console.error('src/App.js: errors in cities', errorsCities);
    }

    // ##### 25-03-05 Komarov
    const errorsTopHotels = window.INITIAL_STATE.tophotels.errors;
    if (process.env.NODE_ENV === 'development' && errorsTopHotels.length > 0) {
      console.error('src/App.js: errors in tophotels', errorsTopHotels);
    }

    // ##### 25-03-05 Komarov
    const errorSiteCypherCodeData =
      window.INITIAL_STATE.siteCypherCodeData?.error;
    if (process.env.NODE_ENV === 'development' && errorSiteCypherCodeData) {
      console.error(
        'src/App.js: error in siteCypherCodeData',
        errorSiteCypherCodeData
      );
    }
  }, []);

  // ##### 24-08-05 Komarov
  function getCurrentTime() {
    return moment();
  }

  function isTimeDifferenceLessThanMinute(oldTime) {
    // Calculate the difference in milliseconds
    const diffInMilliseconds = moment().diff(oldTime);

    // Convert milliseconds to minutes
    const diffInMinutes = diffInMilliseconds / (1000 * 60);

    return Math.abs(diffInMinutes) < 1;
  }

  // ##### 23-12-28 Komarov: Если пользователь был в системе, то атворизуем его
  const user =
    localStorage.getItem('user') && JSON.parse(localStorage.getItem('user'));
  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (!user || user === 'undefined') {
      return;
    }
    dispatch(loggedIn(user));
    // ##### 24-03-21 Komarov
  }, [dispatch, user]);

  // ##### 24-08-05 Komarov
  const promocode = useSelector(state => state.promocode.promocode);

  // ##### 24-08-03 Komarov: Функционал для сохранения Промокода в Redux при работе приложения, когда оно переключается на новый URL и Redux "сбрасывается" к начальному состоянию
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // Actions to perform on app startup
    const savedPromocode =
      localStorage.getItem('promocode') &&
      JSON.parse(localStorage.getItem('promocode'));
    if (
      savedPromocode &&
      isTimeDifferenceLessThanMinute(savedPromocode.timePromocodeSet)
    ) {
      dispatch(setPromoCode(savedPromocode.promocode));
    }
    savedPromocode && localStorage.removeItem('promocode');

    // ##### 24-08-03 Komarov: Перед закрытием приложения или переключением его на новый URL сохраняем значение Промокода в localStorage
    const savePromocode = () => {
      localStorage.setItem(
        'promocode',
        JSON.stringify({
          timePromocodeSet: getCurrentTime(),
          promocode,
        })
      );
    };

    // Handle beforeunload event
    window.addEventListener(
      'beforeunload',
      // Actions to perform before app closure
      savePromocode
    );

    return () => {
      // Cleanup function
      window.removeEventListener('beforeunload', savePromocode);
    };
  }, [dispatch, promocode]);

  // ##### 31-05-24 Komarov
  return (
    <>
      {/* ##### 25-04-17 Komarov */}
      <GtagInit />
      { /* ##### Komarov 2025-07-15 */}
      <BrowserRouter>
        <PaymentServiceProvider value={paymentService}>
          {/* ##### Komarov 2025-10-06: Add RobotsMeta for SEO */}
          <RobotsMeta />
          <Switch>
            <Route
              path={`/:locale(${supportedLangs})`}
              component={LocalizationWrapper}
            />
            <Redirect to={config.defaultLang} />
          </Switch>
          { /* ##### Komarov 2025-07-25 */}
        </PaymentServiceProvider>
      </BrowserRouter>
      <ScrollToTopButton />
    </>
  );
};

// ##### 25-05-02 Komarov
export default App;
